<template>
    <div class="main_div" :key="componentKey">
        <!-- 상단 해더 -->
        <TopBar></TopBar>
        <div style="min-width: 1920px; width: 100%">
            <SideBar />
            <!-- 컨텐츠 영역 -->
            <div class="content-wrap">
                <router-view :key="$route.fullPath" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import TopBar from "@/components/TopBar.vue";
import SideBar from "@/components/SideBar.vue";
import Loading from "@/components/Loading.vue";
import { USER_ROUTES } from "@/assets/route_constants";
import { useAuth } from "@/composables/useAuth";

const { loading, isLoggedIn } = useAuth();
const router = useRouter();
const route = useRoute();

const componentKey = ref(0); // To force re-render if needed

onMounted(() => {
    const homeBasePath = USER_ROUTES.Home.Path;
    if (route.fullPath === homeBasePath) {
        router.push({ name: USER_ROUTES.DashBoard.Name });
    }
});
</script>

<style scoped></style>
